
import { ModelBase } from '../../abstract/model-base.model';

export class PaymentInstallment extends ModelBase {

    static override CLASS_NAME: string = 'PaymentInstallment';

    private _amount!: number;
    private _label!: string;
    private _percentage!: number;

    public get amount(): number {
        return this._amount;
    }

    public set amount(value: any) {
        this._setValue('_amount', value, 'float');
    }

    public get label(): string {
        return this._label;
    }

    public set label(value: any) {
        this._setValue('_label', value, 'string');
    }

    public get percentage(): number {
        return this._percentage;
    }

    public set percentage(value: any) {
        this._setValue('_percentage', value, 'float');
    }

}
